module.exports = __webpack_public_path__ + "img/meXTULYl.03b6e289.svg";